/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ChartItemMusic from '../common/ChartItemMusic.js';

const Trending = ({charts, playPause, goto}) => { 

    return (
        /*
        <style>
            .grey-font a {
                color: #999;
            }
        </style>
        */
        <div className="hblock wow land animated" data-wow-delay="0.7s">
            <button className="btn btn-outline btn-explore transition"  onClick={() => goto('/Charts')}>
                EXPLORE
                <svg className="icon icn-carret transition">
                    <use xlinkHref="#icn-carret" />
                </svg>
            </button>
            <h3 className="head">
                <a href="/Charts">
                    <span className="circicon">
                        <svg className="icon icon-chart transition">
                            <use xlinkHref="#icn-chart" />
                        </svg>
                    </span>
                    CHART
                </a>
            </h3>
            <p>Looking for exciting new music? We have you covered! <Link to="/Charts"><strong>Check out what is trending right now!</strong></Link></p>
            <div className="hchart">
                <a href="#" className="btn-fader" onClick={(event) => event.preventDefault()} />     
                {
                    charts.length == 0 ?
                    <p>There are no tracks currently trending</p>
                    :
                    <ul id="ulHearMe" className="list-unstyled itemlist hearlist hearlist-top hearlist-top-aligned">
                        {charts.slice(0, 4).map((item, index) =>
                            <ChartItemMusic key={item.ID} item={item} playPause={playPause} index ={index} />
                        )}  
                    </ul>
                }
            </div>               
        </div>
    );
};

Trending.propTypes = {
    charts: PropTypes.array.isRequired,
    playPause: PropTypes.func.isRequired,
    goto: PropTypes.func.isRequired
};

export default Trending;